import type { Tracker } from "@/src/features/api/TrackerApi";

export function hasUnreadByWatermark(
  ownerId: string,
  rows: Tracker[],
  getReadAt: (trackerId: string) => number,
): boolean {
  if (!ownerId || !rows.length) {
    return false;
  }
  return rows.some((row) => {
    const lastTriggered = Number(row.last_triggered ?? 0);
    const readAt = getReadAt(row.tracker_id ?? "");
    return lastTriggered > readAt;
  });
}
